import React, { createContext, useContext, useEffect, useMemo } from 'react';
import VideoService from '../services/VideoService';
import BackendService from '../services/BackendService';
import Video from '../components/video/Video'; // Import your Video component

const VideoServiceContext = createContext(null);

export const VideoServiceProvider = ({ children }) => {
  const backendService = useMemo(() => {
    const mockOnLoadingStart = () => {};
    const mockOnLoadingEnd = () => {};
    const mockOnAuthChange = () => {};
    return new BackendService(mockOnLoadingStart, mockOnLoadingEnd, mockOnAuthChange);
  }, []);

  const videoService = useMemo(() => {
    const vs = new VideoService(backendService);
    vs.VideoComponent = Video;
    return vs;
  }, [backendService]);

  useEffect(() => {
    return () => {
      if (videoService.isCameraOn()) {
        videoService.stopCamera();
      }
    };
  }, [videoService]);

  return (
    <VideoServiceContext.Provider value={videoService}>
      {children}
    </VideoServiceContext.Provider>
  );
};

export const useVideoService = () => {
  const context = useContext(VideoServiceContext);
  if (!context) {
    throw new Error('useVideoService must be used within a VideoServiceProvider');
  }
  return context;
};